import { Color, Spacing } from '@persona-id/design-tokens';
import { VFC } from 'react';
import styled from 'styled-components';

import { getVariableDisplay, valueTransformer } from 'dashboard/lib/workflows';
import { VariableConfig } from 'dashboard/models/workflow-version';

const Container = styled.pre<{ hasError: boolean }>`
  border-color: ${({ theme, hasError }) =>
    hasError ? theme.color.variants.danger.default : theme.color.border.input};
  border-width: 2px;
  border-style: solid;
  border-radius: ${({ theme }) => theme.element.borderRadius};
  padding: ${Spacing[3]} ${Spacing[4]};
  margin-bottom: ${Spacing[4]};
  height: 150px;
  overflow: auto;
  background-color: ${Color.CoreSlate1000};
  color: ${Color.CorePurple300};
`;

interface DisplayProps {
  returnVariableId: string;
  variables: VariableConfig[];
  tokensToDisplayValue: Record<string, string>;
  hasError?: boolean;
}

const Display: VFC<DisplayProps> = ({
  returnVariableId,
  variables,
  tokensToDisplayValue,
  hasError = false,
}) => {
  const vt = valueTransformer(tokensToDisplayValue);
  const returnVariableName = vt.getDisplayValue(returnVariableId);
  return (
    <Container hasError={hasError} aria-label='Expression display'>
      {variables.map((variable) => (
        <div key={variable.id}>
          {variable.name} = {getVariableDisplay(variable.value, vt)}
        </div>
      ))}
      <div>return {returnVariableName === returnVariableId ? '' : returnVariableName}</div>
    </Container>
  );
};

export default Display;
